import { render, staticRenderFns } from "./PassportConfigEdit.vue?vue&type=template&id=3052d9d6&scoped=true"
import script from "./PassportConfigEdit.vue?vue&type=script&lang=js"
export * from "./PassportConfigEdit.vue?vue&type=script&lang=js"
import style0 from "./PassportConfigEdit.vue?vue&type=style&index=0&id=3052d9d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3052d9d6",
  null
  
)

export default component.exports